import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LayoutService } from '@core/services/layout/layout.service';
import { ConfiguratorComponent } from '../configurator/configurator.component';

@Component({
  selector: 'd2d-auth-layout',
  imports: [RouterOutlet, ConfiguratorComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <main>
      <router-outlet></router-outlet>
    </main>
    <button
      type="button"
      aria-label="Abrir menú"
      class="fixed top-3 left-3 z-[1100] w-10 h-10 rounded-full grid place-items-center
         bg-primary-600 text-white shadow hover:bg-primary-700
         right-auto bottom-auto"
      (click)="layoutService.showSidebar()"
    >
      <i class="pi pi-bars"></i>
    </button>

    @defer (on idle) {
      <d2d-configurator location="landing" />
    }
  `,
})
export class AuthLayoutComponent {
  layoutService: LayoutService = inject(LayoutService);
}
